import React, { Component } from 'react';
import Header from './Header';
import Capa from './Capa';
import Resumo from './Resumo';
import Form from './Form';

class Ebook extends Component {
  render() {
    return (
      <div>
        <Header path={this.props.match.path} />
        <article className="container row">
          <Capa path={this.props.match.path} />
          <Resumo path={this.props.match.path} />
          <section>
            <Form
              path={this.props.match.path}
              setSubscribed={this.props.setSubscribed}
              isSubscribed={this.props.isSubscribed}
              handleName={this.props.handleName}
              name={this.props.name}
              handleEmail={this.props.handleEmail}
              email={this.props.email}
              handleCpfcnpj={this.props.handleCpfcnpj}
              cpfcnpj={this.props.cpfcnpj}
              handleCpf={this.props.handleCpf}
              cpf={this.props.cpf}
              handleCnpj={this.props.handleCnpj}
              cnpj={this.props.cnpj}
            />
          </section>
        </article>
      </div>
    );
  }

  componentWillMount() {
    const script = document.createElement('script');

    // script.src = 'http://materiais.anbima.com.br/scripts-react/scripts.js';
    script.async = true;
    document.body.appendChild(script);
    // React.createElement("script", {type: "text/javascript", src: "js/scripts.js"});
  }
}
export default Ebook;



// WEBPACK FOOTER //
// ./src/Ebook.js